import { render, staticRenderFns } from "./geo_enfermedades.vue?vue&type=template&id=660fac81"
import script from "./geo_enfermedades.vue?vue&type=script&lang=js"
export * from "./geo_enfermedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports